// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

<div class="click-through" style="position:absolute; width: 100%; height: 100%; display:flex; align-items: flex-end;">
  <observing-panel></observing-panel>
  <template v-for="(item, i) in pluginsGuiComponents">
    <component :is="item" :key="i"></component>
  </template>
  <template v-for="(item, i) in dialogs">
    <component :is="item" :key="i + pluginsGuiComponents.length"></component>
  </template>
  <!-- [guanxing patch] 顶栏移除（用户需求）：信息卡从 top:48px 提到 top:0。 -->
  <!-- [guanxing patch] M-SW52：锁定期知识栏常驻——视角锁定（stel.lock）未解除时
       信息卡不受 UI 空闲自动隐藏（M-SW3d 的 3s 淡出）影响；底栏照旧淡出。 -->
  <selected-object-info :class="{ 'ui-fade': true, 'ui-hidden': $store.state.uiIdle && !isLockResident }" style="position: absolute; top: 0px; left: 0px; width: 380px; max-width: calc(100vw - 12px); margin: 6px" class="get-click"></selected-object-info>
  <progress-bars style="position: absolute; bottom: 54px; right: 12px;"></progress-bars>
  <!-- [guanxing patch] 落地页隐藏底栏（M-SW21c）：landingActive 与 uiIdle 同用
       ui-hidden 淡出机制——落地页挂载期间鼠标移动不会让底栏重现（uiIdle 只管
       空闲，landingActive 期间整条隐藏）。 -->
  <bottom-bar :class="{ 'ui-fade': true, 'ui-hidden': $store.state.uiIdle || $store.state.landingActive }" style="position:absolute; width: 100%; justify-content: center; bottom: 0; display:flex; margin-bottom: 0px" class="get-click"></bottom-bar>
</div>

</template>

<script>
import BottomBar from '@/components/bottom-bar.vue'
import SelectedObjectInfo from '@/components/selected-object-info.vue'
import ProgressBars from '@/components/progress-bars'

import DataCreditsDialog from '@/components/data-credits-dialog.vue'
import ViewSettingsDialog from '@/components/view-settings-dialog.vue'
import PlanetsVisibility from '@/components/planets-visibility.vue'
// [guanxing patch] M-SW9：太阳系视图（orrery）对话框。
import SolarSystemDialog from '@/components/solar-system-dialog.vue'
// [guanxing patch] M-SW38：导出星图（截图 + 预览 + 下载）对话框。
import StarMapExportDialog from '@/components/star-map-export-dialog.vue'
import ObservingPanel from '@/components/observing-panel.vue'

export default {
  data: function () {
    return {
      // 非响应式活动时间戳（不进 data，避免无谓的重渲染）
    }
  },
  mounted: function () {
    // [guanxing patch] UI 自动隐藏（M-SW3d）：鼠标/触摸/按键活动重置计时，
    // 静止 3s 且没有打开的菜单/对话框时置 uiIdle=true，底栏与天体信息卡淡出。
    // 菜单/对话框打开期间（Vuetify 的 .menuable__content__active）绝不隐藏，
    // 防止用户盯着日期选择器或地点面板时 UI 消失。
    var that = this
    this.$_lastActivity = Date.now()
    this.$_resetActivity = function () { that.$_lastActivity = Date.now() }
    this.$_activityEvents = ['mousemove', 'mousedown', 'touchstart', 'keydown', 'wheel']
    this.$_activityEvents.forEach(e => window.addEventListener(e, that.$_resetActivity, { passive: true }))
    this.$_idleTimer = setInterval(function () {
      const overlayOpen = document.querySelector('.menuable__content__active, .v-overlay--active')
      if (overlayOpen) {
        that.$_lastActivity = Date.now()
      }
      const idle = Date.now() - that.$_lastActivity > 3000
      if (idle !== that.$store.state.uiIdle) {
        that.$store.commit('setValue', { varName: 'uiIdle', newValue: idle })
      }
    }, 500)
  },
  beforeDestroy: function () {
    clearInterval(this.$_idleTimer)
    this.$_activityEvents.forEach(e => window.removeEventListener(e, this.$_resetActivity))
  },
  methods: {
  },
  computed: {
    // [guanxing patch] M-SW52：锁定期知识栏常驻——stel.lock 为引擎视角锁定
    // 的响应式镜像（sw_helpers onValueChanged 同步），非空即视为锁定中。
    isLockResident: function () {
      const stel = this.$store.state.stel
      return !!(stel && stel.lock)
    },
    pluginsGuiComponents: function () {
      let res = []
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.guiComponents) {
          res = res.concat(plugin.guiComponents)
        }
      }
      return res
    },
    dialogs: function () {
      let res = [
        'data-credits-dialog',
        'view-settings-dialog',
        'planets-visibility',
        // [guanxing patch] M-SW9：太阳系视图（orrery）。
        'solar-system-dialog',
        // [guanxing patch] M-SW38：导出星图预览。
        'star-map-export-dialog'
      ]
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.dialogs) {
          res = res.concat(plugin.dialogs.map(d => d.name))
        }
      }
      return res
    }
  },
  components: { BottomBar, DataCreditsDialog, ViewSettingsDialog, PlanetsVisibility, SolarSystemDialog, StarMapExportDialog, SelectedObjectInfo, ProgressBars, ObservingPanel }
}
</script>

<style>
/* [guanxing patch] UI 自动隐藏（M-SW3d）：uiIdle 时底栏与天体信息卡淡出；
   pointer-events 一并关掉，避免透明层挡住星空的拖拽与点击。 */
.ui-fade {
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.ui-hidden {
  opacity: 0 !important;
  pointer-events: none !important;
}
.ui-fade:not(.ui-hidden) {
  opacity: 1;
}
</style>
